import { AfterViewInit, Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';

import * as echarts from 'echarts/core';
import {
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
} from 'echarts/components';
import { LineChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import { SimpleArea } from 'src/app/Interfaces/Admin/charts/SimpleChartArea.interface';

@Component({
    selector: 'app-simple-chart-arear',
    templateUrl: './simple-chart-arear.component.html',
    styleUrls: ['./simple-chart-arear.component.scss', '../../../../Components/Styles/GlobalStyles.css'],
    standalone: false
})
export class SimpleChartArearComponent implements OnInit, OnChanges {

  //+===================== INPUTS =====================+\\
  @Input() DataChartArea!: SimpleArea;

  //+================== VARIABLES FOR CHART ==================+\\
  @ViewChild('chartContainer', { static: true }) chartContainer!: ElementRef;

  private MyChart!: echarts.ECharts;

  ngOnInit(): void {
    echarts.use([
      TitleComponent,
      ToolboxComponent,
      TooltipComponent,
      GridComponent,
      LegendComponent,
      LineChart,
      CanvasRenderer,
      UniversalTransition
    ]);

    this.MyChart = echarts.init(this.chartContainer.nativeElement);
    this.updateChart();

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['DataChartArea'] && !changes['DataChartArea'].firstChange) {
      this.updateChart();
    }

  }

  //-================== LOAD CHART OPTIONS AND DATA ==================-\\
  private getChartOptions() {

    var option;

    option = {
      color: ['#20a8e1', '#24D5FF', '#24FAFF'],
      title: {
        left: 'center',
        text: this.DataChartArea.Title ?? '',
        subtext: this.DataChartArea.Subtitle ?? '',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985'
          }
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          data: this.DataChartArea.Date ?? []
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      series: [
        {
          name: this.DataChartArea.SerieName ?? '',
          type: 'line',
          stack: 'Total',
          smooth: true,
          lineStyle: {
            width: 2
          },
          showSymbol: false,
          areaStyle: {
            opacity: 0.8,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#20a8e1'
              },
              {
                offset: 1,
                color: '#24FAFF'
              }
            ])
          },
          emphasis: {
            focus: 'series'
          },
          data: this.DataChartArea.Data ?? []
        }
      ]
    };

    return option
  }

  private updateChart(): void {
    const options = this.getChartOptions();
    this.MyChart.resize();
    this.MyChart.setOption(options);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    if (this.MyChart) {
      this.MyChart.resize();
    }
  }
}
